<template>
  <div class="scheduleCard" v-if="!info.isIncrease">
    <el-popover
      popper-class="scheduleCard_popper"
      placement="right-start"
      :offset="10"
      :visible-arrow="false"
      trigger="click">
      <div class="popover_info">
        <div :class="{ popover_header: true, physio: info.ruleType === '2' }">
          <div class="popover_header_badge">
            <span v-if="!info.isStop && ( info.increaseSchedulingItem ? nowTime > `${info.schedulingItemDateTime.schedulingTime} ${info.increaseSchedulingItem.increaseEndTime}`  : nowTime > info.schedulingItemDateTime.appointmentEndDateTime)" class="popover_header_badge_finished">完诊</span>
            <span v-if="info.isStop" class="popover_header_badge_stop">停诊</span>
          </div>
          <div class="popover_header_title">
            <div class="popover_header_title_tag">{{ info.ruleType === '2' ? '理疗执行' : '门诊' }}</div>
            <div class="popover_header_title_time">{{ timeTypeMap[info.schedulingItemDateTime.timeType] }} {{ info.schedulingItemDateTime.appointmentStartTime.substring(0, 5) }}-{{ info.schedulingItemDateTime.appointmentEndTime.substring(0, 5) }}</div>
            <div class="popover_header_title_room">{{ info.clinic.clinicName }}</div>
          </div>
          <div v-if="!((nowTime > info.schedulingItemDateTime.appointmentEndDateTime) || info.isRegistration)" class="popover_header_tips">{{ nowTime < info.schedulingItemDateTime.releaseTime ? `${new Date(info.schedulingItemDateTime.releaseTime).Format('MM-dd hh:mm')}放号` : `已放号，暂无${info.ruleType === '2' ? '预约' : '挂号'}` }}</div>
        </div>
        <div v-if="info.isRegistration" class="popover_tips">
          <span v-show="info.ruleType === '1'">已有挂号</span>
          <span v-show="info.ruleType === '2'">已有预约</span>
        </div>
        <div class="popover_content">
          <div v-if="info.ruleType === '1'" class="popover_content_list">
            <div v-for="source in sourceList" :key="source.key" v-if="info[source.key].isRegistration === '1'" class="popover_list_item">
              <div class="popover_list_item_name">{{ source.label }}</div>
              <div class="popover_list_item_num">{{ info[source.key].number }}个</div>
              <div class="popover_list_item_price">￥{{ info[source.key].price }}<span class="popover_list_item_price_tag">(普通)</span></div>
              <div class="popover_list_item_addPrice">￥{{ info[source.key].raisePrice }}<span class="popover_list_item_price_tag">(加号)</span></div>
            </div>
          </div>
          <div class="popover_content_increase" v-if="info.increaseSchedulingItem && info.ruleType === '1'">
            <div>
              <span class="popover_content_increase_title">{{ info.increaseSchedulingItem.increaseStartTime }}-{{ info.increaseSchedulingItem.increaseEndTime }}&ensp;{{ info.clinic.clinicName }}</span>
              <span class="popover_content_increase_tips">正常排班号满后放号</span>
            </div>
            <div class="popover_content_increase_list" v-for="source in sourceList" :key="source.key" v-if="info.increaseSchedulingItem[source.increaseKey] && info.increaseSchedulingItem[source.increaseKey].isRegistration === '1'">
              <div class="popover_list_item_name">{{ source.label }}加号</div>
              <div class="popover_list_item_num">{{ info.increaseSchedulingItem[source.increaseKey].number }}个</div>
              <div class="popover_list_item_price">￥{{ info.increaseSchedulingItem[source.increaseKey].price }}</div>
            </div>
          </div>
          <div v-if="info.schedulingItemDateTime.schedulingTime >= nowDate" class="popover_content_footer">
            <div class="popover_content_footer_btn" @click="toEdit">修改</div>
            <!-- <div class="popover_content_footer_btn" @click="toStop">{{ info.isStop ? '取消停诊' : '停诊' }}</div> -->
            <div v-if="!info.isRegistration" class="popover_content_footer_btn" @click="toDelete">删除</div>
          </div>
        </div>
      </div>
      <div slot="reference" :class="{ card: true, expire: info.increaseSchedulingItem ? nowTime > `${info.schedulingItemDateTime.schedulingTime} ${info.increaseSchedulingItem.increaseEndTime}`  : nowTime > info.schedulingItemDateTime.appointmentEndDateTime, physio: info.ruleType === '2', stop: info.isStop }">
        <!-- <div v-if="info.isStop" class="card_stop_title">{{ info.schedulingItemDateTime.schedulingTime < nowDate ? '停诊排班' : '停诊中' }}</div> -->
        <div v-if="info.increaseSchedulingItem && info.increaseSchedulingItem.increaseTimeType == 1" class="mb8">
          <div class="card_label">{{ timeTypeMap[info.schedulingItemDateTime.timeType] }} {{ info.increaseSchedulingItem.increaseStartTime }}-{{ info.increaseSchedulingItem.increaseEndTime }}&ensp;{{ info.clinic.clinicName }}</div>
          <div v-if="info.ruleType === '1'" class="card_list">
            <div v-for="source in sourceList" :key="source.key" v-if="info.increaseSchedulingItem[source.increaseKey] && info.increaseSchedulingItem[source.increaseKey].isRegistration === '1'" class="card_term">
              <div class="card_term_name">{{ source.label }}加号</div>
              <div class="card_term_num">{{ info.increaseSchedulingItem[source.increaseKey].number }}个</div>
              <div class="card_term_price">￥{{ info.increaseSchedulingItem[source.increaseKey].price }}</div>
            </div>
          </div>
        </div>
        <div>
          <div class="card_label">{{ timeTypeMap[info.schedulingItemDateTime.timeType] }} {{ info.schedulingItemDateTime.appointmentStartTime.substring(0, 5) }}-{{ info.schedulingItemDateTime.appointmentEndTime.substring(0, 5) }}&ensp;{{ info.clinic.clinicName }}</div>
          <div v-if="info.ruleType === '1'" class="card_list">
            <div v-for="source in sourceList" :key="source.key" v-if="info[source.key].isRegistration === '1'" class="card_term">
              <div class="card_term_name">{{ source.label }}</div>
              <div class="card_term_num">{{ info[source.key].number }}个</div>
              <div class="card_term_price">￥{{ info[source.key].price }}</div>
            </div>
          </div>
        </div>
        <div v-if="info.increaseSchedulingItem && info.increaseSchedulingItem.increaseTimeType == 2" class="mt8">
          <div class="card_label">{{ timeTypeMap[info.schedulingItemDateTime.timeType] }} {{ info.increaseSchedulingItem.increaseStartTime }}-{{ info.increaseSchedulingItem.increaseEndTime }}&ensp;{{ info.clinic.clinicName }}</div>
          <div v-if="info.ruleType === '1'" class="card_list">
            <div v-for="source in sourceList" :key="source.key" v-if="info.increaseSchedulingItem[source.increaseKey] && info.increaseSchedulingItem[source.increaseKey].isRegistration === '1'" class="card_term">
              <div class="card_term_name">{{ source.label }}加号</div>
              <div class="card_term_num">{{ info.increaseSchedulingItem[source.increaseKey].number }}个</div>
              <div class="card_term_price">￥{{ info.increaseSchedulingItem[source.increaseKey].price }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
  export default {
    name: 'scheduleCard',
    props: {
      info: {
        type: Object,
        default: () => ({
          schedulingItemId: '',
          dept: {
            deptId: '',
            deptName: ''
          },
          doctor: {
            doctorId: '',
            doctorName: ''
          },
          clinic: {
            clinicId: '',
            clinicName: '',
          },
          schedulingItemDateTime: {
            timeType: '1',
            appointmentStartTime: '',
            appointmentStartDateTime: '',
            appointmentEndTime: '',
            appointmentEndDateTime: '',
            timeQuantumCode: '4',
            releaseTime: '',
            releaseDay: '15',
            releasePointTime: '00:00'
          },
          generalVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          physicalVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          contributingVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          freeVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          transferVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          ruleType: '1',
          isStop: false,
          isRegistration: false,
          isIncrease:false,
          increaseSchedulingItem:null
        })
      }
    },
    data() {
      return {
        nowDate: new Date().Format('yyyy-MM-dd'),
        nowTime: new Date().Format('yyyy-MM-dd hh:mm:ss'),
        timeTypeMap: {
          '1': '上午',
          '2': '中午',
          '3': '下午',
          '4': '晚上'
        },
        sourceList: [
          {
            label: '普通',
            key: 'generalVo',
            increaseKey:'commonIncrease'
          },
          {
            label: '理疗',
            key: 'physicalVo',
            increaseKey:'physicalIncrease'
          },
          {
            label: '特约',
            key: 'contributingVo',
            increaseKey:'contributingIncrease'
          },
          {
            label: '义诊',
            key: 'freeVo',
            increaseKey:'freeIncrease'
          },
          {
            label: '转方',
            key: 'transferVo',
            increaseKey:'transferIncrease'
          }
        ]
      }
    },
    methods: {
      toEdit () {
        let data = JSON.parse(JSON.stringify(this.info))
        data = {
          ...data,
          type: 'edit'
        }
        this.$emit('scheduleEdit', data)
      },
      toStop () {
        let data = JSON.parse(JSON.stringify(this.info))
        this.$emit('scheduleStop', data)
      },
      toDelete () {
        let data = JSON.parse(JSON.stringify(this.info))
        this.$emit('scheduleDelete', data)
      }
    }
  }
</script>

<style lang="less" scoped>
  .scheduleCard {
    width: 100%;
  }

  .card {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    padding: 8px 10px;
    width: 100%;
    background-color: #DFF0FF;
    border-radius: 4px;
    overflow: hidden;
  }

  .card.expire {
    opacity: 0.5;
  }

  .card.physio {
    background-color: #E2F8E0;
  }

  .card.stop {
    background-color: #EDEDED;
  }

  .card_stop_title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -8px -10px 0;
    width: calc(100% + 20px);
    height: 18px;
    font-size: 12px;
    color: #667182;
    background-color: #E1E1E1;
  }

  .card_label {
    line-height: 18px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .card_stop_title+.card_label {
    margin: 6px 0 0 0;
  }

  .card_list {
    margin: 6px 0 0 0;
    width: 100%;
  }

  .card_term {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .card_term::before {
    content: '';
    display: block;
    width: 4px;
    height: 4px;
    background-color: #1890FF;
    border-radius: 50%;
    overflow: hidden;
  }

  .card.stop .card_term::before {
    background-color: #C7C7C7;
  }

  .card_term+.card_term {
    margin: 6px 0 0 0;
  }

  .card_term_name {
    margin: 0 0 0 4px;
    line-height: 13px;
    font-size: 13px;
    color: #626262;
  }

  .card_term_num {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 0 8px;
    width: 36px;
    line-height: 13px;
    font-size: 13px;
    color: #626262;
  }

  .card_term_price {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 8px;
    width: 36px;
    line-height: 13px;
    font-size: 13px;
    color: #626262;
  }

  .popover {
    padding: 0px;
    width: fit-content;
  }

  .popover_info {
    width: fit-content;
    min-width: 320px;
  }

  .popover_header {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    padding: 16px;
    width: 100%;
    background-color: #1890FF;
  }

  .popover_header.physio {
    background-color: #29C01B;
  }

  .popover_header_badge {
    position: absolute;
    z-index: 2;
    top: 0px;
    right: 0px;
    width: 40px;
    height: 20px;
    border-radius: 0 0 0 8px;
    overflow: hidden;
  }

  .popover_header_badge_finished {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: #667182;
    background-color: #F0F1F3;
  }

  .popover_header_badge_stop {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: #F54A45;
    background-color: #FFDEDD;
  }

  .popover_header_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .popover_header_title_tag {
    box-sizing: border-box;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 6px;
    height: 20px;
    font-size: 13px;
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
    border-radius: 2px;
  }

  .popover_header_title_time {
    flex-shrink: 0;
    margin: 0 0 0 8px;
    line-height: 16px;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
  }

  .popover_header_title_room {
    margin: 0 0 0 8px;
    line-height: 16px;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
  }

  .popover_header_tips {
    margin: 8px 0 0 0;
    line-height: 13px;
    font-size: 13px;
    color: rgba(255,255,255,0.9);
  }

  .popover_tips {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 24px;
    font-size: 14px;
    color: #FE8F1F;
    background-color: #FFF0E1;
  }

  .popover_content {
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    background-color: #FFFFFF;
  }

  .popover_content_list {
    width: 100%;
  }

  .popover_list_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .popover_list_item::before {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    background-color: #1890FF;
    border-radius: 50%;
    overflow: hidden;
  }

  .popover_list_item+.popover_list_item {
    margin: 8px 0 0 0;
  }

  .popover_list_item_name {
    margin: 0 0 0 6px;
    line-height: 14px;
    font-size: 14px;
    color: #000000;
  }

  .popover_list_item_num {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 0 10px;
    width: 40px;
    line-height: 14px;
    font-size: 14px;
    color: #000000;
  }

  .popover_list_item_price {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 0 10px;
    width: 100px;
    line-height: 14px;
    font-size: 14px;
    color: #000000;
  }

  .popover_list_item_addPrice {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 0 8px;
    width: 100px;
    line-height: 14px;
    font-size: 14px;
    color: #000000;
  }

  .popover_list_item_price_tag {
    color: #667182;
  }

  .popover_content_footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    margin-top: 24px;
  }

  // .popover_content_list+.popover_content_footer {
  //   margin: 24px 0 0 0;
  // }

  .popover_content_footer_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    height: 28px;
    font-size: 14px;
    color: #1F2329;
    border: 1px solid #D3D3D5;
    border-radius: 2px;
    cursor: pointer;
  }

  .popover_content_footer_btn+.popover_content_footer_btn {
    margin: 0 0 0 12px;
  }
  .popover_content_increase{
    padding: 12px;
    background: #F7F8F9;
    margin-top: 16px;
    border-radius: 2px;
  }
  .popover_content_increase_list{
    display: flex;
    align-items: center;
    margin-top: 8px;
  }
  .popover_content_increase_list::before {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    background-color: #1890FF;
    border-radius: 50%;
    overflow: hidden;
  }
  .popover_content_increase_title{
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }
  .popover_content_increase_tips{
    margin-left: 6px;
    font-weight: 400;
    font-size: 12px;
    color: #667182;
  }
</style>

<style lang="less">
  .scheduleCard_popper{
    padding: 0px;
    border-radius: 4px;
    background-color: #FFFFFF;
    border: none;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
    overflow: hidden;
  }
  .scheduleCard_popper[x-placement^=left] {
    margin-right: -10px!important;
  }
  .scheduleCard_popper[x-placement^=right] {
    margin-left: -10px!important;
  }
</style>